"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCamelCase = getCamelCase;
/**
 * Converts a string to camel case.
 * @param {string} name
 * @returns {string}
 */
function getCamelCase(name) {
    return name.replace(/[ -][a-z]/g, (string) => string[1].toUpperCase());
}
//# sourceMappingURL=getCamelCase.js.map